import React from 'react';

import DropdownSchoolGroupMultiple from "../UI/ReactDropdownSchoolGroupMultiple";
import UserInput from "../UI/ReactUserInput";
import SpinnerDiv from "ui/SpinnerDiv";
import {checkError} from 'root/DataFunctions/BaseDataFns'

export default class SchoolEditForm extends React.Component
{
	static get defaultProps() 
	{
		var schoolDetails = {} ;

		schoolDetails.school_id = '' ;
		schoolDetails.school_group_id = null ;
		schoolDetails.school_name = '';
		schoolDetails.address1 = '';
		schoolDetails.address2 = '';
		schoolDetails.address3 = '' ;
		schoolDetails.address4 = '' ;
		schoolDetails.postcode = '';
		schoolDetails.telephone = '' ;
		schoolDetails.email = '' ;
		
	    var v =
	    	{
		    	  school: schoolDetails,
	    	} ;

	    	return v ;
	}
	
	constructor(props)
	{
		super(props);

		this.keyCount = 1;

		// Create a state item here for all items on the form  (Using their id )
		// If you don't create an initial entry here for each input field on the form, then React will assume they are
		// UNCONTROLLED and issue a warning at runtime
		//
		// displayErrors is passed to child controls for force them to display their validity state (for example if the SAVE button is pressed )

		this.state = {
			loading: true,
			mode: this.props.mode,
			displayErrors: false,
			showButtons: props.showButtons,
			userType: props.usertype,
			groups: [],
			school: props.school,
			buttonState: ''
		};

		if ( this.props.displayGroups != null && this.props.displayGroups != false )
		{
			if (this.props.mode == 'view')
			{
				this.getGroupsForSchool(this.props.school.school_id);
			} else
			{
				this.getGroupsForSchool(0);
			}
		}

		if ( this.props.school !== null && this.props.school !== undefined )
		{
			this.state.loading = false ;
		}
	}

	UNSAFE_componentWillReceiveProps(nextProps)
	{
		 this.setState ( { 
		 mode: nextProps.mode,
		 showButtons: nextProps.showButtons,
		 school: nextProps.school 
		 }) ;
	}
	
	getGroupsForSchool( school_id )
	{
		// Globals are defined in the globals.js class
		var root = Globals.APIFolder ;
		
    	$.ajax({
    		  type: 'GET',
    		  url: root + '/schools/' + school_id + '/schoolgroups',
    		  data: { },
    		  success:(data)=>{

    			// We've got something back, so set the data field in the REACT component STATE
    			// THis will be used in the RENDER function
    			  
  				this.setState({ loading: false , groups: data.data });
  				
    		  },
    		  error:(jqXHR, textStatus, error)=>{

					bootbox.alert({ 
					  size: "large",
					  title: "The operation failed",
					  message: error.stack + '\n' + jqXHR.responseText + '<br><br>' + getErrorObject().stack,  
					  callback: function()
					  { 
					  }
					})	    		  	
  		  		}

    		});
	}

	updateSchoolDetails ( schoolObj )
	{
		// Globals are defined in the globals.js class
		var root = Globals.APIFolder ;
		
		var school_id = schoolObj.school_id ;
		
		var data = {} ;

		data.school = schoolObj ;

    	$.ajax({
    		  type: 'PUT',
    		  url: root + '/schools/'+school_id,
    		  data: data ,
    		  success:(data)=>{

				if ( checkError(data))
				{
					this.enableButtons() ;
					
					var message = "School details updated. Click OK to return" ;

					var me = this ;

					this.getGroupsForSchool ( school_id ) ;

					bootbox.alert({ 
						  size: "large",
						  title: "Operation completed",
						  message: message, 
						  callback: function()
						  {
							me.setState ( { displayErrors: false, mode: 'view'}) ;						
						  }
						})				
				}
  				
    		    // successful request; do something with the data
    		    //$('#exampleTextarea').empty();
    		    //$('#exampleTextarea').val(data.name);
    		  },
    		  error:(jqXHR, textStatus, error)=>{
    			  
    			  	this.enableButtons() ;

					bootbox.alert({ 
					  size: "large",
					  title: "The operation failed",
					  message: error.stack + '\n' + jqXHR.responseText + '<br><br>' + getErrorObject().stack, 
					  callback: function()
					  { 
					  }
					})	    		  	
    		  }
    		});
	}

	saveSchoolDetails ( schoolObj )
	{
		// Globals are defined in the globals.js class
		var root = Globals.APIFolder ;
		
		var data = {} ;

		data.school = schoolObj ;

    	$.ajax({
    		  type: 'POST',
    		  url: root + '/schools',
    		  data: data ,
    		  success:(data)=>{

				if ( checkError(data))
				{
					if ( data.status.error == "EXISTS")
					{
						var message = "Failed to create school - A school with this ID already exists" ;

						var me = this ;

						bootbox.alert({ 
							  size: "large",
							  title: "Operation failed",
							  message: message, 
							  callback: function()
							  {
							  }
							})				
						
					}
					else if ( data.status.insertId != 0 )
					{
						var message = "School created. Click OK to return" ;

						var me = this ;

						bootbox.alert({ 
							  size: "large",
							  title: "Operation completed",
							  message: message, 
							  callback: function()
							  {
							  	var returnUrl = atob(me.props.return_url) ;

							  	location.assign ( returnUrl ) ;
							  }
							})				
					
					}
					else
					{
						var message = "Failed to create school" ;

						var me = this ;

						bootbox.alert({ 
							  size: "large",
							  title: "Operation completed",
							  message: message, 
							  callback: function()
							  {
								me.setState ( { displayErrors: false, mode: 'view'}) ;						
							  }
							})				
						
					}
					
				}
  				
    		    // successful request; do something with the data
    		    //$('#exampleTextarea').empty();
    		    //$('#exampleTextarea').val(data.name);
    		  },
    		  error:(jqXHR, textStatus, error)=>{

					bootbox.alert({ 
					  size: "large",
					  title: "The operation failed",
					  message: error.stack + '\n' + jqXHR.responseText + '<br><br>' + getErrorObject().stack, 
					  callback: function()
					  { 
					  }
					})	    		  	
    		  }
    		});
	}

	deleteSchool ( schoolId )
	{
		// Globals are defined in the globals.js class
		var root = Globals.APIFolder ;
		
		var data = {} ;

    	$.ajax({
    		  type: 'DELETE',
    		  url: root + '/schools/'+schoolId,
    		  data: data ,
    		  success:(data)=>{

				if ( checkError(data))
				{
					if ( data.status.error == "EXISTS")
					{
						var message = "Failed to create school - A school with this ID already exists" ;

						var me = this ;

						bootbox.alert({ 
							  size: "large",
							  title: "Operation failed",
							  message: message, 
							  callback: function()
							  {
							  }
							})				
						
					}
					else if ( data.status.rowsAffected != 0 )
					{
						var message = "School deleted. Click OK to return" ;

						var me = this ;

						bootbox.alert({ 
							  size: "large",
							  title: "Operation completed",
							  message: message, 
							  callback: function()
							  {
							  	var returnUrl = atob(me.props.return_url) ;

							  	location.assign ( returnUrl ) ;
							  }
							})				
					
					}
					else
					{
						var message = "Failed to create school" ;

						var me = this ;

						bootbox.alert({ 
							  size: "large",
							  title: "Operation completed",
							  message: message, 
							  callback: function()
							  {
								me.setState ( { displayErrors: false, mode: 'view'}) ;						
							  }
							})				
						
					}
					
				}
  				
    		    // successful request; do something with the data
    		    //$('#exampleTextarea').empty();
    		    //$('#exampleTextarea').val(data.name);
    		  },
    		  error:(jqXHR, textStatus, error)=>{

					bootbox.alert({ 
					  size: "large",
					  title: "The operation failed",
					  message: error.stack + '\n' + jqXHR.responseText + '<br><br>' + getErrorObject().stack, 
					  callback: function()
					  { 
					  }
					})	    		  	
    		  }
    		});
	}


	formIsValid ()
	{		
		var rVal = true ;

		if ( this.state.mode == 'edit')
		{
			if ( this.refs.InputSchoolId.isValid() && 
					 this.refs.InputSchoolName.isValid() && 
					 this.refs.InputEmail.isValid() && 
					 this.refs.InputTelephone.isValid() &&
					 this.refs.InputAddress1.isValid() &&
					 this.refs.InputAddress2.isValid() && 
					 this.refs.InputAddress3.isValid() &&
					 this.refs.InputAddress4.isValid() &&
					 this.refs.InputPostcode.isValid())
					 
				{
					rVal = true ;
				}
				else
				{
					rVal = false ;
				}	
		}
		else if ( this.state.mode == 'create')
		{
			if ( this.refs.InputSchoolId.isValid() && 
			     this.refs.InputSchoolName.isValid() && 
				 this.refs.InputEmail.isValid() && 
				 this.refs.InputTelephone.isValid() &&
				 this.refs.InputAddress1.isValid() &&
				 this.refs.InputAddress2.isValid() && 
				 this.refs.InputAddress3.isValid() &&
				 this.refs.InputAddress4.isValid() &&
				 this.refs.InputPostcode.isValid())
				 
			{
				rVal = true ;
			}
			else
			{
				rVal = false ;
			}			
		}
		else if ( this.props.state == 'delete')
		{
			rVal = true ;
		}
		
		return rVal ;
	}
	
	disableButtons()
	{
		this.setState ( { buttonState: 'disabled'}) ;
	}
	
	enableButtons()
	{
		this.setState ( { buttonState: ''}) ;
	}
	
	getFormData()
	{
		var schoolDetails = {} ;

		schoolDetails.school_id = this.refs.InputSchoolId.getValue() ;
		schoolDetails.school_name = this.refs.InputSchoolName.getValue() ;
		schoolDetails.address1 = this.refs.InputAddress1.getValue() ;
		schoolDetails.address2 = this.refs.InputAddress2.getValue() ;
		schoolDetails.address3 = this.refs.InputAddress3.getValue() ;
		schoolDetails.address4 = this.refs.InputAddress4.getValue() ;
		schoolDetails.postcode = this.refs.InputPostcode.getValue() ;
		schoolDetails.telephone = this.refs.InputTelephone.getValue() ;
		schoolDetails.email = this.refs.InputEmail.getValue() ;

		if ( this.refs.InputSchoolGroups != null )
		{
			schoolDetails.groups = this.refs.InputSchoolGroups.getValue() ;		
		}
		
		return schoolDetails ;
	}
		
	onSave() 
	{
		if ( !this.formIsValid())
		{
			this.setState ( { displayErrors : true }) ;
		}
		else
		{
			this.disableButtons() ;

			var schoolId = this.refs.InputSchoolId.getValue();
			var schoolName = this.refs.InputSchoolName.getValue();
			var email = this.refs.InputEmail.getValue();
			var telephone = this.refs.InputTelephone.getValue();

			var address1 = this.refs.InputAddress1.getValue();
			var address2 = this.refs.InputAddress2.getValue();
			var address3 = this.refs.InputAddress3.getValue();
			var address4 = this.refs.InputAddress4.getValue();

			var postcode = this.refs.InputPostcode.getValue();

			var groups = this.refs.InputSchoolGroups.getValue() ;

			// We are acting as an inline form

			var ob = { school_id: schoolId, 
					   school_name: schoolName,
					   email: email,
					   telephone: telephone,
					   postcode: postcode,
					   address1: address1,
					   address2: address2,
					   address3: address3,
					   address4: address4,
					   groups: groups
					   } ;

			// Pass the form details back to the calling form
			this.saveSchoolDetails (ob) ;
		}		
	}

	onSaveChanges() 
	{
		if ( !this.formIsValid())
		{
			this.setState ( { displayErrors : true }) ;
		}
		else
		{
			this.disableButtons() ;

			var newSchool = this.state.school ;

			var schoolId = this.refs.InputSchoolId.getValue();

			var schoolName = this.refs.InputSchoolName.getValue();
			var email = this.refs.InputEmail.getValue();
			var telephone = this.refs.InputTelephone.getValue();

			var address1 = this.refs.InputAddress1.getValue();
			var address2 = this.refs.InputAddress2.getValue();
			var address3 = this.refs.InputAddress3.getValue();
			var address4 = this.refs.InputAddress4.getValue();

			var postcode = this.refs.InputPostcode.getValue();
			
			var groups = this.refs.InputSchoolGroups.getValue() ;

			if ( this.props.onSave != null )
			{
				// We are acting as an inline form
				
				var ob = { school_id: schoolId, 
						   school_name: schoolName,
						   email: email,
						   telephone: telephone,
						   postcode: postcode,
						   address1: address1,
						   address2: address2,
						   address3: address3,
						   address4: address4,
						   groups: groups
						   } ;

				newSchool.school_id = this.refs.InputSchoolId.getValue() ;
				newSchool.school_name = this.refs.InputSchoolName.getValue() ;
				newSchool.email = this.refs.InputEmail.getValue() ;
				newSchool.telephone = this.refs.InputTelephone.getValue() ;
				newSchool.address1 = this.refs.InputAddress1.getValue() ;
				newSchool.address2 = this.refs.InputAddress2.getValue() ;
				newSchool.address3 = this.refs.InputAddress3.getValue() ;
				newSchool.address4 = this.refs.InputAddress4.getValue() ;
				newSchool.postcode = this.refs.InputPostcode.getValue() ;
				newSchool.groups = this.refs.InputSchoolGroups.getValue() ;

				this.updateSchoolDetails(newSchool) ;

				this.setState ({school:newSchool}) ;

				if ( this.props.onSchoolDetailChange != null )
				{
					this.props.onSchoolDetailChange (ob) ;			
				}
			}
		}
		
	}

	onDelete() 
	{
		this.setState ( { mode: 'delete' });
	}

	onConfirmDelete() 
	{
		this.deleteSchool ( this.props.school.school_id ) ;
	}
	
	onCancel() 
	{
		if ( this.state.mode == 'create')
		{
			this.props.onCancel();
		}
		else
		{
			this.setState ( { mode: 'view' });		
		}
	}
	
	onModify() 
	{
		//var oldSchool = this.state.school ;
		//var oldGroups = this.state.groups ;

		//this.setState ( { old_school: oldSchool, old_groups: oldGroups, mode : 'edit' })
		this.setState ( { mode : 'edit' })
	}

	formIsReadOnly()
	{
		if ( this.props.readonly == true  || this.state.mode == 'view' || this.state.mode == 'delete' )
		{
			return true ;
		}
		else
		{
			return false ;
		}
	}

	row2()
	{
        var lineList=[];	
        
		var fieldType = '';

		if ( this.formIsReadOnly())
		{
			fieldType = "readonly";
		}
		
        lineList.push ( React.createElement('div',  {key: this.keyCount++, className: 'col-md-6'},
        		React.createElement ( UserInput, { 
        			  validation: { required: true, maxlen: 7, isNumber: true, nonZero: true },
        			  id: 'InputSchoolId', 
        			  name: 'InputSchoolId',
        			  ref: 'InputSchoolId',
        			  labelText: 'School Id', 
        			  errorText: 'You must enter a valid non-zero School ID',
        			  value: this.state.school.school_id,
        			  readOnly: fieldType, 
        			  displayErrors:this.state.displayErrors,
        			  key: this.keyCount++
        			  }))) ;

        
        lineList.push ( React.createElement('div',  {key: this.keyCount++, className: 'col-md-6'},
        		React.createElement ( UserInput, { validation: { required: true, maxlen: 200 },
        			  id: 'InputSchoolName', 
        			  name: 'InputSchoolName',
        			  ref: 'InputSchoolName',
        			  labelText: 'School Name', 
        			  errorText: 'You must enter a valid school name',
        			  value: this.state.school.school_name,
        			  readOnly: fieldType, 
        			  displayErrors:this.state.displayErrors,
        			  key: this.keyCount++
        			  }))) ;

        return React.createElement('div',  {key: this.keyCount++, className: 'row'}, lineList );
	}

	row3()
	{
        var lineList=[];	
		
		var fieldType = '';
		
		if ( this.formIsReadOnly())
		{
			fieldType = "readonly";
		}
		
        lineList.push ( React.createElement('div',  {key: this.keyCount++, className: 'col-md-6'},
        		React.createElement ( UserInput, { 
        			  validation: { required: false, maxlen: 100 , isEmail: true},
        			  id: 'InputEmail', 
        			  name: 'InputEmail',
        			  ref: 'InputEmail',
        			  labelText: 'Email Address', 
        			  errorText: 'You must enter a valid email address',
        			  value: this.state.school.email,
        			  readOnly: fieldType, 
        			  displayErrors:this.state.displayErrors,
        			  key: this.keyCount++
        			  }))) ;

        lineList.push ( React.createElement('div',  {key: this.keyCount++, className: 'col-md-6'},
        		React.createElement ( UserInput, { validation: { required: false, maxlen: 15, isTelephone: true },
        			  id: 'InputTelephone', 
        			  name: 'InputTelephone',
        			  ref: 'InputTelephone',
        			  labelText: 'Telephone Number', 
        			  errorText: 'You must enter a valid phone number',
        			  value: this.state.school.phone,
        			  readOnly: fieldType, 
        			  displayErrors:this.state.displayErrors,
        			  key: this.keyCount++
        			  }))) ;
        
        return React.createElement('div',  {key: this.keyCount++, className: 'row'}, lineList );
	}

	row4()
	{
        var lineList=[];	
		
		var fieldType = '';
		
		if ( this.formIsReadOnly())
		{
			fieldType = "readonly";
		}
		
        lineList.push ( React.createElement('div',  {key: this.keyCount++, className: 'col-md-6'},
        		React.createElement ( UserInput, { validation: { required: true, maxlen: 50 },
        	  		  name: 'InputAddress1',
        	  		  ref: 'InputAddress1',
        	  		  labelText: 'Address 1', 
        	  		  errorText: 'You must enter a valid address',
        	  		  value: this.state.school.address1,
        	  		  readOnly: fieldType, 
        	  		  displayErrors:this.state.displayErrors,
        	  		  key: this.keyCount++
        	  		  }))) ;

        lineList.push ( React.createElement('div',  {key: this.keyCount++, className: 'col-md-6'},
        		React.createElement ( UserInput, { validation: { required: false, maxlen: 50 },
        	  		  name: 'InputAddress2',
        	  		  ref: 'InputAddress2',
        	  		  labelText: 'Address 2', 
        	  		  errorText: 'You must enter a valid address',
        	  		  value: this.state.school.address2,
        	  		  readOnly: fieldType, 
        	  		  displayErrors:this.state.displayErrors,
        	  		  key: this.keyCount++
        	  		  }))) ;
        
        return React.createElement('div',  {key: this.keyCount++, className: 'row'}, lineList );
	}
	
	row5()
	{
        var lineList=[];	
		
		var fieldType = '';
		
		if ( this.formIsReadOnly())
		{
			fieldType = "readonly";
		}

        lineList.push ( React.createElement('div',  {key: this.keyCount++, className: 'col-md-6'},
        		React.createElement ( UserInput, { validation: { required: false, maxlen: 50 },
        	  		  name: 'InputAddress3',
        	  		  ref: 'InputAddress3',
        	  		  labelText: 'Address3', 
        	  		  errorText: 'You must enter a valid address',
        	  		  value: this.state.school.address3,
        	  		  readOnly: fieldType, 
        	  		  displayErrors:this.state.displayErrors,
        	  		  key: this.keyCount++
        	  		  }))) ;

        lineList.push ( React.createElement('div',  {key: this.keyCount++, className: 'col-md-6'},
        		React.createElement ( UserInput, { validation: { required: false, maxlen: 50 },
        	  		  name: 'InputAddress4',
        	  		  ref: 'InputAddress4',
        	  		  labelText: 'Address 4', 
        	  		  errorText: 'You must enter a valid address',
        	  		  value: this.state.school.address4,
        	  		  readOnly: fieldType, 
        	  		  displayErrors:this.state.displayErrors,
        	  		  key: this.keyCount++
        	  		  }))) ;
        
        return React.createElement('div',  {key: this.keyCount++, className: 'row'}, lineList );
	}

	row6()
	{
        var lineList=[];	
		
		var fieldType = '';
		
		if ( this.formIsReadOnly())
		{
			fieldType = "readonly";
		}

        lineList.push ( React.createElement('div',  {key: this.keyCount++, className: 'col-md-6'})) ;

        lineList.push ( React.createElement('div',  {key: this.keyCount++, className: 'col-md-6'},
        		React.createElement ( UserInput, { validation: { required: false, maxlen: 10, isPostcode: true },
        	  		  name: 'InputPostcode',
        	  		  ref: 'InputPostcode',
        	  		  labelText: 'Postcode', 
        	  		  errorText: 'You must enter a valid postcode',
        	  		  value: this.state.school.postcode,
        	  		  readOnly: fieldType, 
        	  		  displayErrors:this.state.displayErrors,
        	  		  key: this.keyCount++
        	  		  }))) ;
        
        return React.createElement('div',  {key: this.keyCount++, className: 'row'}, lineList );
	}

	rowSchoolGroup()
	{
        var lineList=[];	
		
		var fieldType = '';
		
		if ( this.formIsReadOnly())
		{
			fieldType = "readonly";
		}
		
		if ( this.state.mode == 'create')
		{
			var currentGroups = [] ;

			if ( this.props.default_group_id != 0)
			{
				currentGroups.push ( this.props.default_group_id );			
			}
		}
		else
		{
			var itemArray = this.state.groups ;

			var currentGroups = [] ;
			var i= 0;
			var len = itemArray.length;

			if ( itemArray != null )
			{
				for (i=0; i<len; ++i) 
				{
					if (i in itemArray) 
					{
						var row = itemArray[i];            		


						if ( row.school_id != null )
						{
							currentGroups.push(row.school_group_id );        			
						}
					}
				}
			}			
		}
    	
    	if ( this.state.school.school_id == '')
    	{
			var school_id = 0 ; 
    	}
    	else
    	{
			var school_id = this.state.school.school_id ;		
    	}

        lineList.push ( React.createElement('div',  {key: this.keyCount++, className: 'col-md-12'},
			 React.createElement(DropdownSchoolGroupMultiple, {  key: this.keyCount++, 
		    ref: 'InputSchoolGroups',
			displayType: 'select',  
			mode: 'multiple',
			school_id: school_id,
			label: 'Select School Groups (Ctrl-Click to select more than one)', 
        	readOnly: fieldType, 
			defaultItems: currentGroups, 
			groups: this.state.groups,
			authorityid:1,
			callback: this.onSchoolGroupChange }, null))) ; 
        
        return React.createElement('div',  {key: this.keyCount++, className: 'row'}, lineList );
	}

	buttonElement ( buttonText, clickHandler, displayClass )
	{
		if ( displayClass == null )
		{
			displayClass = 'btn-primary' ;
		}

		return React.createElement('button', { id: 'getButtonReact', type: 'button', className: 'btn '+displayClass, onClick: clickHandler }, buttonText) ;
	}
		
	buttonRow ()
    {
        var lineList=[];
        
        if ( this.props.showButtons == true )
        {
	        lineList.push ( React.createElement ( 'div',{key: this.keyCount++,className: 'col-md-9'},null)) ;

	        if ( this.state.mode == 'delete')
	    	{
	            lineList.push ( React.createElement ( 'div',{key: this.keyCount++, className: 'col-md-3'},
	            		 React.createElement('button', { id: 'SaveButton', type: 'button', className: 'btn btn-danger', style: { float: 'right', marginRight: '15px' } , onClick: this.onConfirmDelete.bind(this) }, 'Confirm Delete'),
	               		 React.createElement('button', { id: 'CancelButton', type: 'button', className: 'btn btn-secondary', style: {float: 'right', marginRight: '10px' }, onClick: this.onCancel.bind(this) }, 'Cancel')))
	    	
	    	}
	        else if ( this.state.mode == 'edit')
			{
				lineList.push ( React.createElement ( 'div',{key: this.keyCount++, className: 'col-md-3'},
						 React.createElement('button', { id: 'SaveButton', type: 'button', className: 'btn btn-primary', style: { float: 'right' , marginRight: '0px'} , onClick: this.onSaveChanges.bind(this) }, 'Save'),
						 React.createElement('button', { id: 'CancelButton', type: 'button', className: 'btn btn-secondary', style: {float: 'right', marginRight: '10px' }, onClick: this.onCancel.bind(this) }, 'Cancel')))

			}
	        else if ( this.state.mode == 'create')
			{
				lineList.push ( React.createElement ( 'div',{key: this.keyCount++, className: 'col-md-3'},
						 React.createElement('button', { id: 'SaveButton', type: 'button', className: 'btn btn-primary', style: { float: 'right' , marginRight: '0px'} , onClick: this.onSave.bind(this) }, 'Save'),
						 React.createElement('button', { id: 'CancelButton', type: 'button', className: 'btn btn-secondary', style: {float: 'right', marginRight: '10px' }, onClick: this.onCancel.bind(this) }, 'Cancel')))

			}
			else if ( this.state.mode == 'view')
			{
				if ( this.props.teachers != null && this.props.teachers.length != 0 )
				{
					var disableDeleteState = 'disabled' ;					
				}
				else
				{
					var disableDeleteState = '' ;
				}

				lineList.push ( React.createElement ( 'div',{key: this.keyCount++, className: 'col-md-3'},
						 React.createElement('button', { id: 'SaveButton', type: 'button', className: 'btn btn-primary', style: { float: 'right' , marginRight: '0px'} , onClick: this.onModify.bind(this) }, 'Edit'),
						 React.createElement('button', { id: 'CancelButton', type: 'button', disabled: disableDeleteState, className: 'btn btn-danger', style: {float: 'right', marginRight: '10px' }, onClick: this.onDelete.bind(this) }, 'Delete')))	        	
	    	}
	           		        
	        return React.createElement('div', { key: this.keyCount++, className: 'row',  style: {marginTop: '15px' }}, lineList ); 
        }
        else
    	{
	        return React.createElement('div', { key: this.keyCount++, className: 'row'});    	
    	}

    }
	    
	mainFormElement ()
    {
	    var lineList=[];
	    
	    if ( this.props.displayRole == true )
    	{
		    lineList.push ( this.row1()) ;    	
    	}
	    
	    lineList.push ( this.row2()) ;
	    lineList.push ( this.row3()) ;
	    lineList.push ( this.row4()) ;
	    lineList.push ( this.row5()) ;
	    lineList.push ( this.row6()) ;
	    
	    if ( this.props.displayGroups != null )
    	{
	    	if ( this.props.displayGroups != false )
    		{
	    	    lineList.push ( this.rowSchoolGroup()) ;    		
    		}
    	}
	    else
    	{
    	    lineList.push ( this.rowSchoolGroup()) ;    			    	
    	}
	    
        if ( this.props.mode == 'create')
        {
        	if ( this.props.passwordRequired == true )
    		{
            	lineList.push ( this.rowPassword()) ;    		
    		}
        }
        
	    lineList.push ( this.buttonRow()) ;
	    
	    return  lineList ;
    }

	render() 
    {
		this.keyCount=0;

		if ( this.state.loading == true )
		{
	        return <SpinnerDiv />
		}
		else
		{
	        return React.createElement('div', { key: this.state.mode + this.keyCount++}, this.mainFormElement());			
		}
    }
}